import GoTrue, { User } from 'gotrue-js'
import Cookies, { CookieChangeListener } from 'universal-cookie'
import { client } from 'src/api/apollo/client'
import { gql } from '@apollo/client'
// import { textileService } from 'src/api/textile'
import { userCookie as cookieName, UserCookie } from 'src/constants/cookies'
import { api } from 'src/api'
import { initialize } from 'src/api/initialize'

const textileService =
  typeof window !== 'undefined'
    ? require('src/api/textile').textileService
    : undefined

const cookies = new Cookies()

const auth = new GoTrue({
  APIUrl: 'https://betatronikboxer.netlify.app/.netlify/identity', //`${process.env.GATSBY_NETLIFY_IDENTITY_URL}.netlify/identity`,
  setCookie: true
})

// const cookieName = 'user'

type LoginOperation = ({
  email,
  password
}: { [key in 'email' | 'password']: string }) => Promise<any>

const setCookie = (user: User) => {
  const userAuth = user.user_metadata.userAuth
  const expires = new Date(userAuth.msg)
  const domain = 'localhost'
  const value: UserCookie = {
    userAuth: user.user_metadata.userAuth,
    identity: user.app_metadata.cryptoIdentity
  }
  cookies.set(cookieName, value, { expires, path: '/', secure: true })
}

const cacheUser = ({ email }: { email: string }) => {
  client.writeQuery({
    query: gql`
      query User {
        user @client {
          email
        }
      }
    `,
    data: {
      user: { email }
    }
  })
}

export const login: LoginOperation = async ({ email, password }) => {
  const user = await auth.login(email, password, false)
  const identity = user.app_metadata.cryptoIdentity
  setCookie(user)
  cacheUser({ email: user.email })
  initialize()
  return user
}

export const signup = async ({ email, password }: any) => {
  // const curr = auth.currentUser()

  console.log('SIGN UP!', email, password)
  const user = await auth.signup(email, password, {})
  console.log('SIGN UP PAYLOAD', user)
  //   .then((whoot) => console.log('WHOOT', whoot))
  //   .catch((error) => console.log("It's an error", error))
  // // const identity = user.app_metadata.cryptoIdentity
  // if (user) {
  //   setCookie(user)
  //   cacheUser({ email: user.email })
  //   const service = await textileService?.init?.(
  //     user.user_metadata.userAuth,
  //     user.app_metadata.cryptoIdentity
  //   )
  //   return user
  // }
  return user
}

export const confirm = async (token: string) => {
  const user = await auth.confirm(token)
  console.log('CONFIRM', user)
  if (user) {
    setCookie(user)
    initialize()
  }
}

export const logout = async () => {
  auth.currentUser()?.logout()
  cookies.get(cookieName)
  cookies.set(cookieName, {}, { expires: new Date() })
  // console.log('LOGOUT',cookies.get(cookieName))
  cookies.remove(cookieName)
  // console.log('LOGOUT',cookies.get(cookieName) )
  textileService.close()
  client.resetStore()
  api.getState()
  if (typeof window !== 'undefined') window.localStorage.clear()
  return {
    user: auth.currentUser()
  }
}

export const isLoggedIn = (onChange?: CookieChangeListener): boolean => {
  const cookie = cookies.get(cookieName)
  // console.log(cookie)
  if (!cookie) return false
  if (onChange) cookies.addChangeListener(onChange)
  return true
}
